/* eslint-disable no-unused-expressions */
/* eslint-disable no-use-before-define */
import { component } from 'picoapp';

import choozy from 'utils/choozy';

export default component((node) => {
  // Set/Remove Active Class
  const controller = {
    activeIndex: 0,
    init: () => {
      view.init();
    },
    setActiveIndex: (slide) => {
      controller.activeIndex = slide;
    },
  };

  // All things view rendering related
  const view = {
    words: [],
    images: [],
    // Get all the slides and images, add event listeners to each.
    init: () => {
      const { image } = choozy(node);
      view.images = [].concat(image);
      const triggerWords = node.querySelectorAll('strong');

      // since we strip the p tags in desktop, we can safely check if the parent is a div
      // to know if the strong has a div parent, which means this is a trigger word in desktop
      // we do this because strong tags are used in the mobile version as well, but we don't want to have the same functionality on hover
      view.words = [...triggerWords].filter(
        (word) => word.parentElement && word.parentElement.nodeName === 'DIV',
      );

      view.words.forEach((word, index) =>
        word.addEventListener(
          'mouseover',
          ((inputIndex) => () => {
            controller.setActiveIndex(inputIndex);
            view.render();
          })(index),
        ),
      );
      view.render();
    },
    render: () => {
      // Toggle the active class to all the images for desktop.
      view.images.forEach((imageEl) => {
        const { index } = imageEl.dataset;
        imageEl.classList[+index === controller.activeIndex ? 'add' : 'remove']('active');
      });
    },
  };

  controller.init();
});
